import React,{useEffect,useState} from 'react'
import { useNavigate,useLocation } from 'react-router-dom'
import { url,encriptar } from '../Funciones'
import axios from "axios"
export default function Login({setLog,setPerfil}){
    const [user,setUser]=useState("")
    const [clave,setClave]=useState("")
    const [error,setError]=useState(false)
    const navigate=useNavigate()
    const userOnChange=(event)=>{
        setUser(event.target.value)
        setError(false)
    }
    const claveOnChange=(event)=>{
        setClave(event.target.value)
        setError(false)
    }
    const Click=()=>{
        axios.get("https://www.asinova.es/webapi/api/Usuarios")
            .then(res=>{
                const users=res.data
                if (users.find(u=>(u.nick==user || u.email==user) && u.clave==encriptar(clave))!=null){
                    const u=users.find(u=>(u.nick==user || u.email==user) && u.clave==encriptar(clave))
                    setLog(u)
                    setPerfil(u.perfil!=null?u.perfil:null)
                    localStorage.setItem("log",JSON.stringify(u))
                    navigate("/grp/registros")
                }
                else{
                    setError(true)
                }
        })
    }
    return(
        <>
            <h1 style={{textAlign:'center',margin:'0.5rem auto'}}>INICIAR SESIÓN</h1>
            <div className="formulario-vertical" style={error?null:{marginBottom:'1rem'}}>
                <input type="text" name="user" id="user" placeholder="Nick o Email" onChange={userOnChange} className={error?'error':''}/>
                <input type="password" name="clave" id="clave" placeholder="Contraseña" onChange={claveOnChange} className={error?'error':''}/>
            </div>
            {error?<p className='mensaje-error'><b>ERROR: Usuario no encontrado</b></p>:null}
            <a className='btn-form' style={{margin:'0 auto',width:'fit-content',display:'block'}} onClick={Click}>Iniciar</a>
        </>
    )
}